import React from 'react';
import "../../styles/main.scss"

export const Container : React.FunctionComponent<{}> = (props) => {
    return (
        <div className={"container"}>
            {props.children}
        </div>
    )
};